package com.sddamico.swigmore.ds.forms

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.PressableStyle
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.typeCaps
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Button as DomButton
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** An on/off switch with its label, for the green field: gold track when on. */
@Composable
fun Toggle(
  label: String,
  checked: Boolean,
  modifier: Modifier = Modifier,
  disabled: Boolean = false,
  onChange: (Boolean) -> Unit,
) {
  DomButton(
    attrs = PressableStyle.toModifier()
      .css("display" to "flex", "align-items" to "center", "gap" to "10px", "padding" to "4px 0",
        "border" to "none", "background" to "transparent", "color" to SwColor.cream, "border-radius" to "7px",
        "cursor" to if (disabled) "not-allowed" else "pointer", "opacity" to if (disabled) ".6" else "1")
      .then(modifier)
      .toAttrs {
        attr("type", "button")
        attr("role", "switch")
        attr("aria-checked", checked.toString())
        if (disabled) attr("disabled", "")
        onClick { onChange(!checked) }
      }
  ) {
    Span(
      attrs = Modifier.css(
        "position" to "relative", "flex" to "0 0 auto", "width" to "38px", "height" to "22px", "border-radius" to "11px",
        "box-sizing" to "border-box", "transition" to "background .15s",
        "background" to if (checked) SwColor.gold else SwColor.disabledOnField,
        "border" to "1.5px solid ${if (checked) SwColor.gold else SwColor.borderStrongOnField}",
      ).toAttrs()
    ) {
      Span(
        attrs = Modifier.css(
          "position" to "absolute", "top" to "2px", "left" to if (checked) "18px" else "2px", "width" to "15px",
          "height" to "15px", "border-radius" to "50%", "transition" to "left .15s",
          "background" to if (checked) SwColor.field700 else SwColor.cream,
        ).toAttrs()
      )
    }
    Span(attrs = Modifier.typeCaps("11px", ".14em").toAttrs()) { Text(label) }
  }
}
